import { TaskActionTypes } from './task.types'

//Add Task
export const addTaskRequest = data => ({
    type: TaskActionTypes.ADD_TASK_REQUEST,
    payload: data
})

export const addTaskRequestSuccess = data => ({
    type: TaskActionTypes.ADD_TASK_REQUEST_SUCCESS,
    payload: data
})

export const addTaskRequestError = data => ({
    type: TaskActionTypes.ADD_TASK_REQUEST_ERROR,
    payload: data
})

export const addTaskRequestStatus = data => ({
    type: TaskActionTypes.ADD_TASK_REQUEST_STATUS,
    payload: data
})

//Update Task Detail
export const updateTaskDetailRequest = data => ({
    type: TaskActionTypes.UPDATE_TASK_DETAIL_REQUEST,
    payload: data
})

export const updateTaskDetailRequestSuccess = data => ({
    type: TaskActionTypes.UPDATE_TASK_DETAIL_REQUEST_SUCCESS,
    payload: data
})

export const updateTaskDetailRequestError = data => ({
    type: TaskActionTypes.UPDATE_TASK_DETAIL_REQUEST_ERROR,
    payload: data
})


export const updateTaskDetailRequestStatus = data => ({
    type: TaskActionTypes.UPDATE_TASK_DETAIL_REQUEST_STATUS,
    payload: data
})

//Update Task Status
export const updateTaskStatusRequest = data => ({
    type: TaskActionTypes.UPDATE_TASK_STATUS_REQUEST,
    payload: data
})

export const updateTaskStatusRequestSuccess = data => ({
    type: TaskActionTypes.UPDATE_TASK_STATUS_REQUEST_SUCCESS,
    payload: data
})

export const updateTaskStatusRequestError = data => ({
    type: TaskActionTypes.UPDATE_TASK_STATUS_REQUEST_ERROR,
    payload: data
})

export const updateTaskStatusRequestStatus = data => ({
    type: TaskActionTypes.UPDATE_TASK_STATUS_REQUEST_STATUS,
    payload: data
})

//Assign Task
export const assignTaskRequest = data => ({
    type: TaskActionTypes.ASSIGN_TASK_REQUEST,
    payload: data
})

export const assignTaskRequestSuccess = data => ({
    type: TaskActionTypes.ASSIGN_TASK_REQUEST_SUCCESS,
    payload: data
})

export const assignTaskRequestError = data => ({
    type: TaskActionTypes.ASSIGN_TASK_REQUEST_ERROR,
    payload: data
})

export const assignTaskRequestStatus = data => ({
    type: TaskActionTypes.ASSIGN_TASK_REQUEST_STATUS,
    payload: data
})

//Task List
export const taskListRequest = data => ({
    type: TaskActionTypes.TASK_LIST_REQUEST,
    payload: data
})

export const taskListRequestSuccess = data => ({
    type: TaskActionTypes.TASK_LIST_REQUEST_SUCCESS,
    payload: data
})

export const taskListRequestError = data => ({
    type: TaskActionTypes.TASK_LIST_REQUEST_ERROR,
    payload: data
})

//Task Detail
export const taskDetailRequest = data => ({
    type: TaskActionTypes.TASK_DETAIL_REQUEST,
    payload: data
})

export const taskDetailRequestSuccess = data => ({
    type: TaskActionTypes.TASK_DETAIL_REQUEST_SUCCESS,
    payload: data
})

export const taskDetailRequestError = data => ({
    type: TaskActionTypes.TASK_DETAIL_REQUEST_ERROR,
    payload: data
})

//Add Task Comment
export const addTaskCommentRequest = data => ({
    type: TaskActionTypes.ADD_TASK_COMMENT_REQUEST,
    payload: data
})

export const addTaskCommentRequestSuccess = data => ({
    type: TaskActionTypes.ADD_TASK_COMMENT_REQUEST_SUCCESS,
    payload: data
})

export const addTaskCommentRequestError = data => ({
    type: TaskActionTypes.ADD_TASK_COMMENT_REQUEST_ERROR,
    payload: data
})

export const addTaskCommentRequestStatus = data => ({
    type: TaskActionTypes.ADD_TASK_COMMENT_REQUEST_STATUS,
    payload: data
})